import PauseCircleOutlined from '@mui/icons-material/PauseCircleOutlined';
import { SxProps, Theme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { t } from 'i18next';

interface JobPausedIndicatorProps {
  sx?: SxProps<Theme>;
}

export default function JobPausedIndicator({ sx }: JobPausedIndicatorProps) {
  return (
    <Tooltip title={t('job_events.paused')}>
      <PauseCircleOutlined
        sx={[
          (theme) => ({
            color: theme.brandV2.colors.treadBlue,
            height: '20px',
            width: '20px',
          }),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      />
    </Tooltip>
  );
}
